import { FieldReviewTable } from '../fieldReviewTable';

export interface ClosingInstructionLetterReviewTableProps {
  data: Record<string, any>;
}

export const ClosingInstructionLetterReviewTable = ({
  data,
}: ClosingInstructionLetterReviewTableProps) => {
  return <FieldReviewTable items={data?.items} />;
};
